import { render, staticRenderFns } from "./TeamGame.vue?vue&type=template&id=e6d838f2&scoped=true&"
import script from "./TeamGame.vue?vue&type=script&lang=js&"
export * from "./TeamGame.vue?vue&type=script&lang=js&"
import style0 from "./TeamGame.vue?vue&type=style&index=0&id=e6d838f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d838f2",
  null
  
)

/* custom blocks */
import block0 from "./TeamGame.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports